// eslint-disable-next-line


import React from 'react'

import SimpleTable from '../../SimpleTable/SimpleTable'
import SimplePopUp from '../../SimplePopUp/SimplePopUp'
import SimpleDeletePopUp from '../../SimpleDeletePopUp/SimpleDeletePopUp'
import DepartmentsForm from './DepartmentsForm'
import LocationCityOutlinedIcon from '@material-ui/icons/LocationCityOutlined';

import axios from 'axios'
import AlertMessage from "../../Notify/AlertMessage";
import ProgressBar from "../../ProgressBar/ProgressBar";
import * as CommonFunction from "../../Custom/CommonFunctions"

class Departments extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      model: 'Department',
      Departments: [],
      openPopup: false,
      openDeletePopup: false,
      department: {},
      initialDepartment: {id: '', name: '', short_name: '', description: '', rank: ''},
      title: '',
      load: false,
      tableHead: ['Name', 'short_name', 'description'],
      withShow: false,
      withEdit: true,
      maxWidth: 'sm',
      error_messages: '',
      notify: {},
      isOpen: false,
      message: '',
      type: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.handleCreateorUpdateItem = this.handleCreateorUpdateItem.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleOpenDeletePopup = this.handleOpenDeletePopup.bind(this)
    this.handleDeleteClose = this.handleDeleteClose.bind(this)
    this.handleCloseAlert = this.handleCloseAlert.bind(this)
    this.handleSwitch = this.handleSwitch.bind(this)
  }

  componentDidMount() {
    this.loadDepartments(process.env.REACT_APP_API_DOMAIN + '/v1/departments')
  }

  loadDepartments(url) {
    axios({
      method: 'get',
      url: url,
      headers: {'X-API-ACCESS-TOKEN': localStorage.getItem('api_key')}
    }).then(resp => {
      this.setState({Departments: resp.data})
      this.setState({load: true})
    }).catch(error => this.setState(CommonFunction.handleApiRequestsErrors(error)))
  }

  handleSubmit() {
    const item = this.state.department
    var method = ''
    var url = ''
    if (item.id === '') {
      method = 'post'
      url = process.env.REACT_APP_API_DOMAIN + '/v1/departments/'
    } else {
      method = 'put'
      url = process.env.REACT_APP_API_DOMAIN + '/v1/departments/' + item.id
    }
    axios({
      method: method,
      url: url,
      data: (item),
      headers: {'X-API-ACCESS-TOKEN': localStorage.getItem('api_key')}
    }).then(resp => {

      const newData = resp.data
      this.setState({
        Departments: this.state.Departments.filter(department => department.id !== item.id)
      })
      this.setState({Departments: [...this.state.Departments, newData]})
      this.setState({openPopup: false})
      this.setState({
        isOpen: true,
        message: 'Submitted Successfully',
        type: 'success'
      })
    }).catch(error => {
      if (error.response.status === 422) {
        this.setState({error_messages: 'Name ' + error.response.data.errors.name[0]})
      } else {
        this.setState({
          isOpen: true,
          message: error.response.status.toString() + " Unexpected Error Problem Occurred",
          type: 'error'
        })
        this.setState({openPopup: false})
      }
    })
  }

  handleDeleteItem() {
    const DeleteItemId = this.state.department.id
    axios({
      method: 'delete',
      url: process.env.REACT_APP_API_DOMAIN + '/v1/departments/' + DeleteItemId,
      headers: {'X-API-ACCESS-TOKEN': localStorage.getItem('api_key')}
    }).then(() => {
      this.setState({
        Departments: this.state.Departments.filter(item => item.id !== DeleteItemId)
      })
      this.setState({openDeletePopup: false})
      this.setState({
        isOpen: true,
        message: 'Deleted Successfully',
        type: 'error'
      })
    }).catch(error => this.setState(CommonFunction.handleApiRequestsErrors(error)))
  }

  handleClose() {
    this.setState({openPopup: false})
    this.setState({openDeletePopup: false})
    this.setState({error_messages: ''})
  }

  handleCreateorUpdateItem(item, isAdd) {
    var textTitle = ''
    if (isAdd) {
      textTitle = 'Create ' + "department"
    } else {
      textTitle = 'Edit ' + "department"
    }
    this.setState({openPopup: true})
    this.setState({department: item})
    this.setState({title: textTitle})
  }

  handleInputChange(e) {
    this.setState({
      department: {
        ...this.state.department,
        [e.target.name]: e.target.value
      }
    })
  }

  handleOpenDeletePopup(item, model) {
    this.setState({model: model})
    this.setState({department: item})
    this.setState({openDeletePopup: true})
  }

  handleDeleteClose() {
    this.setState({openDeletePopup: false})
  }

  handleCloseAlert(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({isOpen: false})
  }

  handleSwitch(event) {
    const value = event.target.checked
    this.setState({
      department: {
        ...this.state.department,
        [event.target.name]: value
      }
    })
  }

  render() {
    return (
      <>
        {
          this.state.load ? (
            <div>
              <SimpleTable
                handleClick={this.handleCreateorUpdateItem}
                initialItem={this.state.initialDepartment}
                items={this.state.Departments}
                model={this.state.model}
                onOpenDeletePopup={this.handleOpenDeletePopup}
                headers={this.state.tableHead}
                withShow={this.state.withShow}
                withEdit={this.state.withEdit}
                icon={<LocationCityOutlinedIcon fontSize="large"/>}
                headerTitle="Departments"
                createUsingSimplePopup={true}
                hasDeleteButton={true}
                handleShowPopUp={this.handleShowPopUp}
              />

              <SimplePopUp
                openPopup={this.state.openPopup}
                title={this.state.title}
                handleClose={this.handleClose}
                maxWidth={this.state.maxWidth}
              >
                <DepartmentsForm
                  error={this.state.error_messages}
                  item={this.state.department}
                  submit={this.handleSubmit}
                  handleSwitch={this.handleSwitch}
                  onchange={this.handleInputChange}/>
              </SimplePopUp>

              <SimpleDeletePopUp
                openDeletePopup={this.state.openDeletePopup}
                item={this.state.department}
                delete={this.handleDeleteItem}
                handleDeleteClose={this.handleClose}
                model="department"
              />
              <AlertMessage
                notify={this.state.notify}
                handleCloseAlert={this.handleCloseAlert}
                isOpen={this.state.isOpen}
                type={this.state.type}
                message={this.state.message}
              />
            </div>
          ) : (
            <ProgressBar model={this.state.model}/>
          )}
      </>
    )
  }
}

export default Departments
